/**
 * @see https://docs.pos.payyo.ch/docs/resources/devices/
 */
const DeviceActionStatus = Object.freeze({
    FAILED: 'failed',
    IN_PROGRESS: 'in_progress',
    SUCCEEDED: 'succeeded',
});

module.exports = DeviceActionStatus;
